import { Link } from 'react-router-dom';
import { articleCategories, articles } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Home() {
  const latestArticles = articles
    .filter((a) => a.isNew)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 6);

  const hotArticles = articles
    .filter((a) => a.isHot)
    .sort((a, b) => b.views - a.views)
    .slice(0, 6);

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '51黑料网',
    url: 'https://51heiliaowang.com/',
    description: '51黑料网分区导航页，集中展示一区二区、每日大赛专区等分类入口，提供黑料一区、黑料二区及黑料大赛专区的最新分区内容。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://51heiliaowang.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=dark%20futuristic%20digital%20city%20skyline%20at%20night%20with%20glowing%20red%20and%20gold%20neon%20lights%2C%20cyberpunk%20aesthetic%2C%20data%20streams%2C%20abstract%20geometric%20patterns%2C%20dark%20background%20with%20dramatic%20lighting%2C%20cinematic%20wide%20shot%2C%20mysterious%20atmosphere&width=1600&height=900&seq=hero-bg-51hlw&orientation=landscape"
                alt="51黑料网分区导航背景"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-background-50" />
            </div>

            <div className="relative z-10 w-full px-4 md:px-6 text-center">
              <div className="max-w-4xl mx-auto">
                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
                  <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse" />
                  <span className="text-xs font-medium text-accent-300 whitespace-nowrap">实时更新中</span>
                </div>

                <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-50 mb-4 leading-tight">
                  51黑料网
                  <span className="block text-xl md:text-2xl lg:text-3xl font-normal text-foreground-200 mt-2">
                    一区二区 · 每日大赛 · 黑料分区导航
                  </span>
                </h1>
                <p className="text-sm md:text-base text-foreground-300 max-w-2xl mx-auto mb-8 leading-relaxed">
                  集中展示<strong>黑料一区</strong>、<strong>黑料二区</strong>及<strong>黑料大赛专区</strong>的最新分区内容，
                  提供最新导航入口，方便按区浏览黑料动态，掌握一手资讯
                </p>

                {/* Category Quick Nav */}
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  {articleCategories.map((cat) => (
                    <Link
                      key={cat.key}
                      to={`/category/${cat.slug}`}
                      className="group w-full sm:w-auto px-6 py-3 rounded-lg bg-background-100/80 backdrop-blur-sm border border-background-200/50 hover:border-primary-500/50 transition-all duration-300 whitespace-nowrap"
                    >
                      <span className="text-sm font-medium text-foreground-100 group-hover:text-primary-500 transition-colors">
                        {cat.name}
                      </span>
                      <span className="ml-2 text-xs text-foreground-500">
                        <i className="ri-arrow-right-line" />
                      </span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            {/* Scroll indicator */}
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
              <i className="ri-arrow-down-s-line text-2xl text-foreground-400" />
            </div>
          </section>

          {/* Zone Cards Section */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-8 md:mb-10">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-2">
                  黑料分区导航
                </h2>
                <p className="text-sm text-foreground-400">选择分区，按区浏览最新黑料动态</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
                {articleCategories.map((cat, index) => {
                  const count = articles.filter((a) => a.category === cat.key).length;
                  const icons = ['ri-radar-line', 'ri-fire-line', 'ri-trophy-line'];
                  const gradients = [
                    'from-accent-500/20 to-accent-600/10',
                    'from-primary-500/20 to-primary-600/10',
                    'from-secondary-500/20 to-secondary-600/10',
                  ];
                  const borderColors = [
                    'border-accent-500/30 hover:border-accent-500/60',
                    'border-primary-500/30 hover:border-primary-500/60',
                    'border-secondary-500/30 hover:border-secondary-500/60',
                  ];

                  return (
                    <Link
                      key={cat.key}
                      to={`/category/${cat.slug}`}
                      className="group relative overflow-hidden rounded-xl border bg-background-100/60 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                    >
                      <div className={`absolute inset-0 bg-gradient-to-br ${gradients[index]} opacity-0 group-hover:opacity-100 transition-opacity duration-300`} />
                      <div className={`relative p-5 md:p-6 border ${borderColors[index]} rounded-xl`}>
                        <div className="flex items-start justify-between mb-3">
                          <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-background-200/50 group-hover:bg-background-300/50 transition-colors`}>
                            <i className={`${icons[index]} text-xl md:text-2xl text-foreground-200 group-hover:text-accent-500 transition-colors`} />
                          </div>
                          <span className="text-xs text-foreground-500 bg-background-200/50 px-2 py-1 rounded-md whitespace-nowrap">
                            {count} 篇内容
                          </span>
                        </div>
                        <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-50 mb-2 group-hover:text-primary-500 transition-colors">
                          {cat.name}
                        </h3>
                        <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                          {cat.description}
                        </p>
                        <span className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap">
                          进入分区 <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                        </span>
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>
          </section>

          {/* Latest Articles */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100/50">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6 md:mb-8">
                <div>
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
                    最新爆料
                  </h2>
                  <p className="text-xs text-foreground-500 mt-1">实时追踪最新黑料动态</p>
                </div>
                <Link
                  to="/category/zone1"
                  className="text-sm text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  查看更多 <i className="ri-arrow-right-line ml-1" />
                </Link>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {latestArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/40 hover:border-primary-500/30 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                  >
                    <div className="relative aspect-[16/9] overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute top-3 left-3">
                        <span className="px-2 py-1 rounded-md text-xs font-medium bg-accent-500/80 text-foreground-50 whitespace-nowrap">
                          {article.categoryName}
                        </span>
                      </div>
                      <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent opacity-60" />
                    </div>
                    <div className="p-4">
                      <h3 className="font-medium text-foreground-100 text-sm md:text-base line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors leading-snug">
                        {article.title}
                      </h3>
                      <p className="text-xs text-foreground-400 line-clamp-2 mb-3 leading-relaxed">
                        {article.excerpt}
                      </p>
                      <div className="flex items-center justify-between text-xs text-foreground-500">
                        <span>{article.date}</span>
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line" /> {article.views.toLocaleString()}
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Hot Content */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6 md:mb-8">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500/20">
                    <i className="ri-fire-line text-accent-500" />
                  </div>
                  <div>
                    <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
                      热门推荐
                    </h2>
                    <p className="text-xs text-foreground-500 mt-1">网友热议内容</p>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
                {hotArticles.map((article, index) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group flex flex-col sm:flex-row gap-4 p-4 rounded-xl bg-background-100 border border-background-200/40 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
                  >
                    <div className="relative w-full sm:w-48 h-36 sm:h-32 flex-shrink-0 rounded-lg overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute top-2 left-2">
                        <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-accent-500 text-foreground-50 whitespace-nowrap">
                          HOT
                        </span>
                      </div>
                    </div>
                    <div className="flex-1 min-w-0 flex flex-col justify-between">
                      <div>
                        <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                          <span className="text-[10px] px-1.5 py-0.5 rounded bg-primary-500/15 text-primary-400 whitespace-nowrap">
                            {article.categoryName}
                          </span>
                          <span className="text-xs text-foreground-500">{article.date}</span>
                        </div>
                        <h3 className="font-medium text-foreground-100 text-sm md:text-base line-clamp-2 mb-1.5 group-hover:text-primary-500 transition-colors leading-snug">
                          {article.title}
                        </h3>
                        <p className="text-xs text-foreground-400 line-clamp-2 leading-relaxed">
                          {article.excerpt}
                        </p>
                      </div>
                      <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
                        <span className="flex items-center gap-1">
                          <i className="ri-eye-line" /> {article.views.toLocaleString()} 阅读
                        </span>
                        <span>{article.author}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Stats Section */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100/50">
            <div className="max-w-5xl mx-auto">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                {[
                  { value: '12', unit: '篇', label: '今日更新', icon: 'ri-file-list-3-line' },
                  { value: '50万+', unit: '', label: '日均访问', icon: 'ri-user-line' },
                  { value: '3', unit: '个', label: '内容分区', icon: 'ri-layout-grid-line' },
                  { value: '24h', unit: '', label: '实时更新', icon: 'ri-timer-line' },
                ].map((stat) => (
                  <div key={stat.label} className="text-center p-4 rounded-xl bg-background-100 border border-background-200/40">
                    <div className="w-8 h-8 mx-auto mb-2 flex items-center justify-center rounded-lg bg-primary-500/10">
                      <i className={`${stat.icon} text-primary-500 text-sm`} />
                    </div>
                    <div className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
                      {stat.value}
                      <span className="text-sm font-normal text-foreground-400 ml-1">{stat.unit}</span>
                    </div>
                    <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}